module.exports = __webpack_public_path__ + "assets/fbf55156a84dec00efb22b36fa0db49c-Logo.png";